module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forget-wrapper"
  }, [_c('div', {
    staticClass: "forget"
  }, [_vm._m(0), _vm._v(" "), (_vm.isEmailSent) ? _c('p', {
    staticStyle: {
      "font-size": "1.6em"
    }
  }, [_vm._v("A message has been sent to " + _vm._s(_vm.ruleForm.email) + " with instructions on how to reset your password.")]) : _vm._e(), _vm._v(" "), (!_vm.isEmailSent) ? _c('p', {
    staticStyle: {
      "font-size": "1.6em"
    }
  }, [_vm._v("Submit your email address and we’ll send you a link to reset your password.")]) : _vm._e(), _vm._v(" "), (!_vm.isEmailSent) ? _c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rulesPass,
      "label-width": "120px",
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Email",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "email",
      "type": "text",
      "auto-complete": "off"
    },
    on: {
      "keyup": function($event) {
        if (('keyCode' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitForm('ruleForm')
      }
    },
    model: {
      value: (_vm.ruleForm.email),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "email", $$v)
      },
      expression: "ruleForm.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('el-button', {
    staticClass: "el-button-login",
    attrs: {
      "type": "primary",
      "loading": _vm.isSubmitButtonLoading
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("Submit")])], 1)], 1) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticStyle: {
      "color": "#000"
    }
  }, [_c('b', [_vm._v("Reset Your LuxTag Password")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b5c914f4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Forgot.vue
// module id = 1192
// module chunks = 6